import { render, staticRenderFns } from "./newsletter-form-page.vue?vue&type=template&id=419a78b4&"
import script from "./newsletter-form-page.vue?vue&type=script&lang=js&"
export * from "./newsletter-form-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports